import React from 'react';
import { color } from '@core-ds/primitives';
import { ThemeProvider } from 'styled-components';

const blackOnWhite = {
   fontColor: color.black,
   buttonColor: color.white,
   buttonHoverColor: color.gray2,
};

const whiteOnBlack = {
   fontColor: color.white,
   buttonColor: color.black,
   buttonHoverColor: color.gray8,
};

const whiteOnBlue = {
   fontColor: color.white,
   buttonColor: color.blue,
   buttonHoverColor: color.blueDark1,
};

const getTheme = name => {
   switch (name) {
      case 'BLACK_ON_WHITE':
         return blackOnWhite;
      case 'WHITE_ON_BLACK':
         return whiteOnBlack;
      case 'WHITE_ON_BLUE':
         return whiteOnBlue;
      default:
         return blueTheme;
   }
};

const withTheme = Component => {
   return props => {
      const { theme: themeName, ...withOutTheme } = props;
      const theme = getTheme(themeName);
      return (
         <ThemeProvider theme={theme}>
            <Component {...withOutTheme} />
         </ThemeProvider>
      );
   };
};

export { withTheme };
